module.exports = __webpack_public_path__ + "img/IQ.66216bd0.svg";